import * as React from 'react';

const BoltOffFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="bolt-off-fill_svg__eds-icon--bolt-off-fill_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bolt-off-fill_svg__eds-icon--bolt-off-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2L8.7 8l-6-6-.7.7L21.3 22l.7-.7-6.3-6.3L19 9h-7V2z"
        />
        <path
            className="bolt-off-fill_svg__eds-icon--bolt-off-fill_bottom"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 15h7v7l2.6-4.9-7-7z"
        />
    </svg>
);

BoltOffFillSvg.displayName = 'BoltOffFillSvg';
export default BoltOffFillSvg;
